module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-equ-e03fe32f8446370ba2cac52ffacf5d75.png";